import { render, staticRenderFns } from "./AmmunitionAddEdit.vue?vue&type=template&id=627b0414&"
import script from "./AmmunitionAddEdit.vue?vue&type=script&lang=ts&"
export * from "./AmmunitionAddEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports